import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { observeOn, asyncScheduler } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private subject = new BehaviorSubject<boolean>(false);

  // ✅ force async emission
  readonly loading$ = this.subject.asObservable().pipe(
    observeOn(asyncScheduler)
  );

  show(): void {
    this.subject.next(true);
  }

  hide(): void {
    this.subject.next(false);
  }
}